export default "__VITE_ASSET___5$WYeZm__"